export type EventKey = string | symbol;
export type EventHandler<T = any> = (payload: T) => void;
export type EventMap = Record<EventKey, EventHandler>;

class EventListener {
  bus: { [key: EventKey]: EventHandler[] };
  constructor() {
    this.bus = {};
  }

  on(key: EventKey, handler?: EventHandler) {
    if (this.bus[key] === undefined) {
      this.bus[key] = [];
    }
    this.bus[key]?.push(handler as any);
  }

  once(key: EventKey, handler?: EventHandler) {
    // @ts-ignore
    const handleOnce = (payload: Parameters<typeof handler>) => {
      handler?.(payload);
      this.off(key, handleOnce as typeof handler);
    };
    this.on(key, handleOnce as typeof handler);
  }

  off(key: EventKey, handler?: EventHandler) {
    if (this.bus[key]) {
      this.bus[key] = this.bus[key].filter(cb => cb !== handler);
    }
  }

  emit<K extends EventKey>(key: K, payload?: any) {
    this.bus[key]?.forEach(fn => {
      try {
        fn(payload);
      } catch (e) {
        console.log('event bus emit error', e);
      }
    });
  }
}

export default EventListener;
